import {Injectable} from '@angular/core';
import {DocumentModel} from "../model/document.model";
import {DocumentSummaryModel} from "../model/documentSummary.model";
import {DocumentRepository} from "../../impl/service/ngrx/document.repository";
import {DocumentSummaryDataServiceAdapter} from "../../impl/service/ngrx/documentSummaryDataService.adapter";
import {AbstractFindOneByIdService} from "../../../../core/service/v2/service/findone/abstractFindOneById.service";
import {DocumentDataServiceAdapter} from "../../impl/service/ngrx/documentDataService.adapter";

@Injectable()
export class DocumentFindOneByIdService extends AbstractFindOneByIdService<DocumentModel, DocumentModel>{
    constructor(repository: DocumentRepository, dataServiceAdapter: DocumentDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

}
